const initialState = {
    invoices: [],
    currentInvoice: null,
    loading: false,
};

const invoicesReducer = (state = initialState, action) => {
    switch (action.type) {
        case "FETCH_INVOICES_REQUEST":
            return {...state, loading: true, error: null};
        case "FETCH_INVOICES_SUCCESS":
            return {...state, loading: false, invoices: action.payload};
        case "FETCH_INVOICE_REQUEST":
            return {...state, loading: true, error: null};
        case "FETCH_INVOICE_SUCCESS":
            return {...state, currentInvoice: action.payload, loading: false};
        case "ADD_INVOICE_SUCCESS":
            return {...state, invoices: [action.payload, ...state.invoices]};
        case "UPDATE_INVOICE_SUCCESS":
            return {
                ...state,
                invoices: state.invoices.map((invoice) =>
                    invoice.id === action.payload.id ? action.payload : invoice
                ),
            };
        case "DELETE_INVOICE_SUCCESS":
            return {
                ...state,
                invoices: state.invoices.filter((invoice) => invoice.id !== action.payload),
            };
        default:
            return state;
    }
};

export default invoicesReducer;
